import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['template', 'container']

  connect() {
    this.tenantCount = this.containerTarget.querySelectorAll('[data-tenant-section]').length
  }

  add(event) {
    event.preventDefault()
    this.tenantCount++

    const template = this.templateTarget.content.cloneNode(true)
    this.updateIndices(template, this.tenantCount)

    this.containerTarget.appendChild(template)
  }

  remove(event) {
    event.preventDefault()
    const tenantSection = event.target.closest('[data-tenant-section]')

    if (this.tenantCount > 1) {
      tenantSection.remove()
      this.tenantCount--
      this.reindexTenants()
    }
  }

  updateIndices(element, index) {
    const fields = element.querySelectorAll('[name], [id], [for]')

    fields.forEach(field => {
      ['name', 'id', 'for'].forEach(attr => {
        if (field.hasAttribute(attr)) {
          const value = field.getAttribute(attr)
          const newValue = value.replace(/tenants\[\d+\]/, `tenants[${index}]`)
          field.setAttribute(attr, newValue)
        }
      })
    })
  }

  reindexTenants() {
    const sections = this.containerTarget.querySelectorAll('[data-tenant-section]')
    sections.forEach((section, index) => {
      this.updateIndices(section, index + 1)
    })
  }
}
